:host {
  display: contents;
}

.br-table-header {
  display: contents;
}
